import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { faSliders } from "@fortawesome/free-solid-svg-icons";
import ReactSelect from "react-select";
import { useParams } from "react-router-dom";
import { API, get } from "../../config";
import { formatName, formatSubcontractorName } from "./Misc";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { MultiSelect } from "primereact/multiselect";
import { debounce } from "lodash";

const FilterCardPopup = ({
  filter,
  setFilter,
  sort,
  setSort,
  sortOptions,
  handleSort,
  filterOptions,
  handleFilter,
  isPopupVisible,
  setIsPopupVisible,
  setLoading,
  handleFetch,
  setGlobalContactSelect,
  setGlobalContractSelect,
  setPage,
}) => {
  const params = useParams();
  const projectId = params?.project_id;
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [selectedMainContacts, setSelectedMainContacts] = useState([]);
  const [contactOptions, setContactOptions] = useState([]);
  const [contactCurrentPage, setContactCurrentPage] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [contactListLoading, setContactListLoading] = useState(false);

  const [selectedContracts, setSelectedContracts] = useState(null);
  const [selectedMainContracts, setSelectedMainContracts] = useState([]);
  const [contractOptions, setContractOptions] = useState([]);
  const [contractCurrentPage, setContractCurrentPage] = useState(1);
  const [contractHasMoreData, setContractHasMoreData] = useState(true);
  const [contractListLoading, setContractListLoading] = useState(false);

  const filterContactInputRef = useRef();
  const filterContractInputRef = useRef();

  const popupRef = useRef(null);
  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
  };

  const clearFilter = () => {
    setFilter();
    setSort();
    setIsPopupVisible(false);
    myContractResetFunction();
    myContactResetFunction();
  };

  const handleOutsideClick = (event) => {
    // Close popup if the click is outside the popup
    if (
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      !filterContactInputRef.current?.container?.contains(event.target) &&
      !filterContractInputRef.current?.container?.contains(event.target) &&
      !document.querySelector(".p-multiselect-panel")?.contains(event.target)
    ) {
      setIsPopupVisible(false);
    }
  };

  useEffect(() => {
    if (isPopupVisible) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    // Clean up event listener on unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPopupVisible]);

  const handleContactChange = (e) => {
    setSelectedContacts(e.value);
    // setSelectedMainContacts(e.value);
    // myContractResetFunction();
    setSelectedContracts([]);
    // setGlobalContractSelect && setGlobalContractSelect([]);
  };

  const handleApplyFilter = () => {
    setSelectedMainContacts(selectedContacts);
    setPage && setPage(1);
    setGlobalContactSelect && setGlobalContactSelect(selectedContacts);
    setPage && setPage(1);
    filterContactInputRef.current.hide();
    myContractResetFunction();
  };

  const myContactResetFunction = () => {
    setSelectedContacts([]);
    setSelectedMainContacts([]);
    setPage && setPage(1);
    setGlobalContactSelect && setGlobalContactSelect([]);
    setPage && setPage(1);
    myContractResetFunction();
    filterContactInputRef && filterContactInputRef.current.focus();
  };

  const handleContactList = useCallback(
    async (page) => {
      if (page !== 1 && (contactListLoading || !hasMoreData)) return;
      if (page === 1) {
        setContactOptions([]);
      }
      try {
        setContactListLoading(true);
        let response = await get(
          `${API.GET_CONTRACTORS}?builder_project_id=${
            projectId ? projectId : ""
          }&with_pta=1&limit=25&sort_column=name&sort_order=ASC&page=${page}`
        );
        if (response?.data?.status === 200) {
          const list =
            response &&
            response?.data?.data?.data?.length > 0 &&
            response?.data?.data?.data?.map((item) => {
              const list = {
                label:
                  item?.is_pta === 0
                    ? `${formatName(item?.first_name, item?.last_name)} (RTA)`
                    : item?.is_pta === 1
                    ? `${formatName(item?.first_name, item?.last_name)} (PTA)`
                    : item?.is_pta === 2
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Withdrawal)`
                    : item?.is_pta === 3
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Principal)`
                    : item?.is_pta === 4
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Trustee)`
                    : formatSubcontractorName(item),
                value: item?.id,
              };
              return list;
            });
          // setContactOptions(list);
          // setLoading(false);
          let contactItemList = list ? list : [];
          setContactOptions((prev) => [...prev, ...contactItemList]);
          setContactCurrentPage(response?.data?.data?.current_page);
          // Update `hasMoreData` when the last page is reached
          if (
            response?.data?.data?.current_page >=
              response?.data?.data?.last_page ||
            response?.data?.data?.data.length === 0
          ) {
            setHasMoreData(false);
          } else {
            setHasMoreData(true);
          }
          setContactListLoading(false);
        }
      } catch (error) {
        setContactListLoading(false);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [projectId]
  );

  useEffect(() => {
    handleContactList(1);
  }, [handleContactList]);

  const contactLoadMoreData = useCallback(
    (event) => {
      const { last } = event;

      // Trigger API call if scrolled near the end of the loaded data
      if (!contactListLoading && hasMoreData && last >= contactOptions.length) {
        handleContactList(contactCurrentPage + 1);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contactListLoading, hasMoreData, contactOptions.length]
  );

  const fetchContactSearchData = async (query) => {
    if (query) {
      try {
        setContactListLoading(true);
        const response = await get(
          `${API.GET_CONTRACTORS}?builder_project_id=${
            projectId ? projectId : ""
          }&search=${
            query ? query : ""
          }&with_pta=1&limit=25&sort_column=name&sort_order=ASC&page=1`
        );
        if (response?.data?.status === 200) {
          const list =
            response &&
            response?.data?.data?.data?.length > 0 &&
            response?.data?.data?.data?.map((item) => {
              const list = {
                label:
                  item?.is_pta === 0
                    ? `${formatName(item?.first_name, item?.last_name)} (RTA)`
                    : item?.is_pta === 1
                    ? `${formatName(item?.first_name, item?.last_name)} (PTA)`
                    : item?.is_pta === 2
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Withdrawal)`
                    : item?.is_pta === 3
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Principal)`
                    : item?.is_pta === 4
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Trustee)`
                    : formatSubcontractorName(item),
                value: item?.id,
              };
              return list;
            });
          setContactOptions(list);
          setContactCurrentPage(response?.data?.data?.current_page);
          // Update `hasMoreData` when the last page is reached
          if (
            response?.data?.data?.current_page >=
              response?.data?.data?.last_page ||
            response?.data?.data?.data.length === 0
          ) {
            setHasMoreData(false);
          } else {
            setHasMoreData(true);
          }
          setContactListLoading(false);
        }
      } catch (error) {
        setContactListLoading(false);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    }
  };

  const debouncedFetchData = useMemo(
    () => debounce(fetchContactSearchData, 300),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Handle filtering
  const handleContactSearch = (event) => {
    const query = event.filter;
    debouncedFetchData(query); // Call debounced function
  };

  // Clean up the debounced function on unmount
  useMemo(() => () => debouncedFetchData.cancel(), [debouncedFetchData]);

  const handleContactFilter = async (e) => {
    if (e?.filter) {
      if (contactOptions?.length > 0 && contactOptions?.find((item) => item?.label?.includes(e?.filter))) {
      } else {
        await handleContactSearch(e);
      }
    } else {
      await handleContactList(1);
    }
  };

  const handleContractChange = (e) => {
    setSelectedContracts(e.value);
    // setSelectedMainContracts(e.value);
  };

  const handleContractApplyFilter = () => {
    setSelectedMainContracts(selectedContracts);
    setPage && setPage(1);
    setGlobalContractSelect && setGlobalContractSelect(selectedContracts);
    setPage && setPage(1);
    filterContractInputRef.current.hide();
  };

  const myContractResetFunction = () => {
    setSelectedContracts([]);
    setSelectedMainContracts([]);
    setPage && setPage(1);
    setGlobalContractSelect && setGlobalContractSelect([]);
    setPage && setPage(1);
    filterContractInputRef && filterContractInputRef.current.focus();
  };

  const handleContractList = useCallback(
    async (page) => {
      if (page !== 1 && (contractListLoading || !contractHasMoreData)) return;
      if (page === 1) {
        setContractOptions([]);
      }
      try {
        if (selectedContacts != null) {
          setContractListLoading(true);
          let response = await get(
            `${API.GET_CONTRACTS}?contact_id=${selectedContacts}&builder_project_id=${projectId}&limit=25&page=${page}`
          );
          if (response?.data?.status === 200) {
            const list =
              response &&
              response?.data?.data?.data?.length > 0 &&
              response?.data?.data?.data?.map((item) => {
                const list = {
                  label: item?.contract_number,
                  value: item?.id,
                };
                return list;
              });
            // setContractOptions(list ? list : []);
            let contractItemList = list ? list : [];
            setContractOptions((prev) => [...prev, ...contractItemList]);
            setContractCurrentPage(response?.data?.data?.current_page);
            // Update `hasMoreData` when the last page is reached
            if (
              response?.data?.data?.current_page >=
                response?.data?.data?.last_page ||
              response?.data?.data?.data.length === 0
            ) {
              setContractHasMoreData(false);
            } else {
              setContractHasMoreData(true);
            }
            setContractListLoading(false);
          }
        }
      } catch (error) {
        // setLoading(false);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [projectId, selectedContacts]
  );

  useEffect(() => {
    handleContractList(1);
  }, [handleContractList]);

  const contractLoadMoreData = useCallback(
    (event) => {
      const { last } = event;

      // Trigger API call if scrolled near the end of the loaded data
      if (
        !contractListLoading &&
        contractHasMoreData &&
        last >= contractOptions.length
      ) {
        handleContractList(contractCurrentPage + 1);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [contractListLoading, contractHasMoreData, contractOptions.length]
  );

  const fetchContractSearchData = async (query) => {
    if (query) {
      try {
        setContractListLoading(true);
        const response = await get(
          `${API.GET_CONTACTS}?builder_project_id=${
            projectId ? projectId : ""
          }&search=${
            query ? query : ""
          }&with_pta=1&limit=25&sort_column=name&sort_order=ASC&page=1`
        );
        if (response?.data?.status === 200) {
          const list =
            response &&
            response?.data?.data?.data?.length > 0 &&
            response?.data?.data?.data?.map((item) => {
              const list = {
                label:
                  item?.is_pta === 0
                    ? `${formatName(item?.first_name, item?.last_name)} (RTA)`
                    : item?.is_pta === 1
                    ? `${formatName(item?.first_name, item?.last_name)} (PTA)`
                    : item?.is_pta === 2
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Withdrawal)`
                    : item?.is_pta === 3
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Principal)`
                    : item?.is_pta === 4
                    ? `${formatName(
                        item?.first_name,
                        item?.last_name
                      )} (Trustee)`
                    : formatSubcontractorName(item),
                value: item?.id,
              };
              return list;
            });
          setContractOptions(list);
          setContractCurrentPage(response?.data?.data?.current_page);
          // Update `hasMoreData` when the last page is reached
          if (
            response?.data?.data?.current_page >=
              response?.data?.data?.last_page ||
            response?.data?.data?.data.length === 0
          ) {
            setContractHasMoreData(false);
          } else {
            setContractHasMoreData(true);
          }
          setContractListLoading(false);
        }
      } catch (error) {
        setContractListLoading(false);
        if (error?.response?.data?.errors) {
          Object.keys(error?.response?.data?.errors).forEach((key) => {
            toast.error(error?.response?.data?.errors[key][0]);
          });
        } else {
          toast.error(error?.message);
        }
      }
    }
  };

  const debouncedContractFetchData = useMemo(
    () => debounce(fetchContractSearchData, 300),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Handle filtering
  const handleContractSearch = (event) => {
    const query = event.filter;
    debouncedContractFetchData(query); // Call debounced function
  };

  // Clean up the debounced function on unmount
  useMemo(
    () => () => debouncedContractFetchData.cancel(),
    [debouncedContractFetchData]
  );

  const handleContractFilter = async (e) => {
    if (e?.filter) {
      if (contractOptions?.find((item) => item?.label?.includes(e?.filter))) {
      } else {
        await handleContractSearch(e);
      }
    } else {
      await handleContractList(1);
    }
  };

  useEffect(() => {
    // handleFetch(selectedMainContacts, selectedMainContracts);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMainContacts, selectedMainContracts]);

  return (
    <div className="filter-sort-body">
      {/* Filter Icon */}
      <button
        onClick={togglePopup}
        className="filter-btn"
        title="Filter and Sorting"
      >
        <FontAwesomeIcon icon={faSliders} />
      </button>

      {/* Popup Card */}
      {isPopupVisible && (
        <div ref={popupRef} className="filter-card-body">
          <div className="filter-sort">
            <div className="form-group refund-card-content">
              <label>Filter By</label>
              <ReactSelect
                name="project_status"
                value={
                  filter
                    ? filterOptions?.find((item) => item?.value === filter)
                    : ""
                }
                onChange={(e) => {
                  handleFilter(e);
                }}
                options={filterOptions}
                placeholder="Select Filter By "
                classNamePrefix="selectbox"
                autoComplete="off"
                onKeyPress={(e) => {
                  e.which === 13 && e.preventDefault();
                }}
                isSearchable={false}
              />
            </div>
            <div className="form-group refund-card-content">
              <label>Sort By</label>
              <ReactSelect
                name="project_status"
                value={
                  sort ? sortOptions?.find((item) => item?.value === sort) : ""
                }
                onChange={(e) => {
                  handleSort(e);
                }}
                options={sortOptions}
                placeholder="Select Sort By "
                classNamePrefix="selectbox"
                autoComplete="off"
                onKeyPress={(e) => {
                  e.which === 13 && e.preventDefault();
                }}
                isSearchable={false}
              />
            </div>
            <div className="form-group refund-card-content">
              <label>Subcontractor</label>
              <MultiSelect
                value={selectedContacts}
                onChange={(e) => {
                  handleContactChange(e);
                }}
                options={
                  contactOptions?.length > 0
                    ? contactOptions?.filter(
                        (option, index, self) =>
                          index ===
                          self.findIndex((o) => o.value === option.value)
                      )
                    : []
                }
                showSelectAll={false}
                optionLabel="label"
                filter
                placeholder="Select Subcontractor(s)"
                maxSelectedLabels={0}
                selectedItemsLabel={`${selectedContacts?.length} Subcontractor(s) Selected`}
                onHide={() => {
                  setSelectedMainContacts(selectedContacts);
                  setPage && setPage(1);
                  setGlobalContactSelect &&
                    setGlobalContactSelect(selectedContacts);
                  setPage && setPage(1);
                  myContractResetFunction();
                }}
                style={{
                  fontSize: "13px",
                  maxWidth: "350px",
                }}
                loading={contactListLoading}
                onFilter={(e) => handleContactFilter(e)}
                virtualScrollerOptions={{
                  lazy: true, // Enables lazy loading
                  onLazyLoad: contactLoadMoreData, // Triggered on scroll
                  itemSize: 40, // Height of each item
                }}
                ref={filterContactInputRef}
                panelFooterTemplate={
                  <>
                    <Button
                      className="multiSelect-button"
                      onClick={() => {
                        handleApplyFilter();
                      }}
                    >
                      Apply
                    </Button>
                    <Button
                      className="multiSelect-button"
                      onClick={() => {
                        myContactResetFunction();
                      }}
                    >
                      Reset
                    </Button>
                  </>
                }
              />
            </div>
            <div className="form-group refund-card-content">
              <label>Contracts</label>

              <MultiSelect
                value={selectedContracts}
                onChange={(e) => {
                  handleContractChange(e);
                }}
                showSelectAll={false}
                options={
                  contractOptions?.length > 0
                    ? contractOptions?.filter(
                        (option, index, self) =>
                          index ===
                          self.findIndex((o) => o.value === option.value)
                      )
                    : []
                }
                disabled={selectedContacts?.length === 0}
                title={
                  selectedContacts?.length === 0
                    ? "Please Select Subcontractor First"
                    : ""
                }
                optionLabel="label"
                filter
                placeholder="Select Contract(s)"
                maxSelectedLabels={0}
                selectedItemsLabel={`${selectedContracts?.length} Contract(s) Selected`}
                onHide={() => {
                  setSelectedMainContracts(selectedContracts);
                  setPage && setPage(1);
                  setGlobalContractSelect &&
                    setGlobalContractSelect(selectedContracts);
                  setPage && setPage(1);
                }}
                style={{
                  fontSize: "13px",
                  maxWidth: "350px",
                }}
                loading={contractListLoading}
                onFilter={(e) => handleContractFilter(e)}
                virtualScrollerOptions={{
                  lazy: true, // Enables lazy loading
                  onLazyLoad: contractLoadMoreData, // Triggered on scroll
                  itemSize: 40, // Height of each item
                }}
                ref={filterContractInputRef}
                panelFooterTemplate={
                  <>
                    <Button
                      className="multiSelect-button"
                      onClick={() => {
                        handleContractApplyFilter();
                      }}
                    >
                      Apply
                    </Button>
                    <Button
                      className="multiSelect-button"
                      onClick={() => {
                        myContractResetFunction();
                        setSelectedMainContracts([]);
                      }}
                    >
                      Reset
                    </Button>
                  </>
                }
              />
            </div>
            <button className="clear-btn" onClick={() => clearFilter()}>
              Clear
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterCardPopup;
